import { createContext, useCallback, useContext, useEffect, useState } from "react";
import type { ReactNode } from "react";
import { endpoints } from "./api";
import { useAuth } from "./auth";

interface NotifyCtx {
  /** Master switch — when off, the app raises no notification alerts. */
  notify: boolean;
  /** Flip the switch and persist it to the account (applies across devices). */
  setNotify: (on: boolean) => void;
}

const Ctx = createContext<NotifyCtx>({ notify: true, setNotify: () => {} });

export function NotifyProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [notify, setNotifyState] = useState(true);

  useEffect(() => {
    if (!user) return;
    endpoints
      .getSettings()
      .then((s) => setNotifyState(s.notify))
      .catch(() => {});
  }, [user]);

  const setNotify = useCallback((on: boolean) => {
    setNotifyState(on);
    void endpoints.saveSettings({ notify: on }).catch(() => {});
  }, []);

  return <Ctx.Provider value={{ notify, setNotify }}>{children}</Ctx.Provider>;
}

export function useNotify() {
  return useContext(Ctx);
}
